import HoverTooltip from '@deltek/specification-client/core/Feedbacks/HoverTooltip'
import GridItem from '@deltek/specification-client/core/Surfaces/GridItem'
import { IconButton } from '@material-ui/core'

import clsx from 'clsx'
import { elementsGroupToggleStyles } from 'components/ElementsTree/styles/elementsGroupToggleStyles'
import { ElementPanelSubItem } from 'models/projectElements'
import {
    CompleteMenuItemConfig,
    WorkspacePopover,
} from 'pages/ProjectsPage/WorkspacePage/components/WorkspacePopover'
import {
    ADDED_TO_PROJECT,
    ALL_PROJECTS_ELEMENTS_TEXT,
} from 'pages/ProjectsPage/WorkspacePage/constants'
import React, { useRef } from 'react'
import ElementsFilterIcon from './ElementsFilterIcon'

export interface ElementsToggleFilterMenuProps {
    selectedGrouppingType?: ElementPanelSubItem
    handleChangeFilterOption?: (value: ElementPanelSubItem) => void
    isSearchBarHiddenInSMMOM?: boolean
}

export const ElementsToggleFilterMenu = ({
    selectedGrouppingType,
    handleChangeFilterOption,
    isSearchBarHiddenInSMMOM,
}: ElementsToggleFilterMenuProps) => {
    const classes = elementsGroupToggleStyles({
        isSearchBarHiddenInSMMOM,
    })
    const [isElementFilterOpened, setIsElementFilterOpened] = React.useState<
        boolean
    >(false)
    const elementsFilterRef = useRef<HTMLButtonElement | null>(null)

    const onSelectFilterOption = React.useCallback(
        (filterType: string) => {
            handleChangeFilterOption?.({
                value: filterType,
                type: selectedGrouppingType?.type ?? '',
            })
            setTimeout(() => setIsElementFilterOpened(false), 200)
        },
        [selectedGrouppingType, handleChangeFilterOption]
    )
    const activateFilterContainer = React.useMemo(
        () =>
            isElementFilterOpened ||
            selectedGrouppingType?.value === 'Added to Project',
        [isElementFilterOpened, selectedGrouppingType]
    )
    const elementsFilterMenuItem: CompleteMenuItemConfig[] = React.useMemo(
        () => [
            {
                dataTestId: 'all-project-elements',
                label: ALL_PROJECTS_ELEMENTS_TEXT,
                onClick: () => onSelectFilterOption(ALL_PROJECTS_ELEMENTS_TEXT),
            },
            {
                dataTestId: 'added-to-project',
                label: ADDED_TO_PROJECT,
                onClick: () => onSelectFilterOption(ADDED_TO_PROJECT),
            },
        ],
        [selectedGrouppingType]
    )

    const anchorOrigin = React.useMemo(() => {
        return {
            vertical:
                ((elementsFilterRef.current as Element)?.clientHeight ?? 0) +
                122,
            horizontal:
                ((elementsFilterRef.current as Element)?.clientWidth ?? 0) - 18,
        }
    }, [elementsFilterRef])

    const toggleFilterMenu = React.useCallback(() => {
        setIsElementFilterOpened(!isElementFilterOpened)
    }, [isElementFilterOpened])

    return (
        <GridItem>
            <HoverTooltip text="Filter Elements" placements={['right']}>
                <IconButton
                    data-testid="elementTypeFilterButton"
                    ref={elementsFilterRef}
                    size="small"
                    onClick={toggleFilterMenu}
                    className={clsx(
                        activateFilterContainer && classes.activeFilterContainer
                    )}
                >
                    <ElementsFilterIcon
                        className={clsx(
                            classes.leftPanelFilterIcon,
                            activateFilterContainer
                                ? classes.activeFilterIcon
                                : classes.filterIcon
                        )}
                    />
                </IconButton>
            </HoverTooltip>
            <WorkspacePopover
                menuItems={elementsFilterMenuItem}
                anchorElement={elementsFilterRef.current}
                isActionPopoverDisplayed={isElementFilterOpened}
                handleActionPopoverClick={toggleFilterMenu}
                customTextStyle={classes.filterMenuText}
                anchorOrigin={anchorOrigin}
            />
        </GridItem>
    )
}
